module.exports = __webpack_public_path__ + "img/02i_marketing.ca8fc055.jpg";